import axiosInstance from "../utils/axios";

function getFeaturesApi(merchantCode: string) {
  return axiosInstance
    .get(`/features/v1/availability/${merchantCode}`);
}

function getFeaturesRequirements() {
  return axiosInstance.get(`/features/v1/requirements`);
}

export { getFeaturesApi, getFeaturesRequirements };
